var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"overlay",staticClass:"overlay"},[_c('p',{staticClass:"overlay-header",style:({ background: _vm.color })},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"overlay-content"},[_vm._t("overlay")],2),_vm._v(" "),_c('img',{staticClass:"overlay-icon",attrs:{"src":_vm.iconCardSrc,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }